import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { getAcademyUrlPublic, getCommunityUrlPublic, getDataSyncAppCollectionUrl, getDataUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getNonProfitsUrlPublic, getStartupsUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { handleClickFrequentlyAskedQuestionLink } from './trackFrequentlyAskedQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const dataHubHref = getDataUrlPublic();
const dataSyncHref = getDataSyncAppCollectionUrl();
const startupsHref = getStartupsUrlPublic('pricing-datapage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-datapage');
export const DataHubFaqs = () => {
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          dataHubLink: /*#__PURE__*/_jsx(Link, {
            href: dataHubHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatIsDataHub',
                url: dataHubHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataHub.learnMore"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataStudio.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatIsDataStudio.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataHubVsSmartCRM.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataHubVsSmartCRM.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataConnectionsDifference.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.dataConnectionsDifference.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          dataSyncAppCollection: /*#__PURE__*/_jsx(Link, {
            href: dataSyncHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.thirdPartyApps',
                url: dataSyncHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.thirdPartyApps.dataSyncAppCollection"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.creditBasedPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.creditBasedPricing.answer"
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatSupport',
                url: communityHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatSupport',
                url: langHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatSupport',
                url: academyHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatSupport',
                url: kbHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatSupport.hubSpotKnowledgeBase"
            })
          })
        }
      })
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatDiscounts',
                url: startupsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.hubSpotForStartups"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: function () {
              handleClickFrequentlyAskedQuestionLink({
                value: 'data.whatDiscounts',
                url: nonprofitsHref,
                trackingSource: 'faq'
              });
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.data.whatDiscounts.hubSpotForNonprofits"
            })
          })
        }
      })
    })]
  });
};